(() => {
  const section = document.querySelector('[data-shir7-influencers]');
  if (!section) return;

  const modal = section.querySelector('[data-shir7-inf-modal]');
  const modalVideo = modal?.querySelector('[data-shir7-inf-modal-video]');
  const modalImage = modal?.querySelector('[data-shir7-inf-modal-image]');
  const openers = Array.from(section.querySelectorAll('[data-shir7-inf-open]'));
  const closers = modal?.querySelectorAll('[data-shir7-inf-modal-close]');
  const prevBtn = modal?.querySelector('[data-shir7-inf-prev]');
  const nextBtn = modal?.querySelector('[data-shir7-inf-next]');

  if (!modal || !openers.length) return;

  const PHOTO_STORY_MS = 5000;
  let currentIndex = 0;
  let photoTimer = null;

  const clearPhotoTimer = () => {
    if (photoTimer) {
      clearTimeout(photoTimer);
      photoTimer = null;
    }
  };

  const clearVideo = () => {
    if (!modalVideo) return;
    modalVideo.pause();
    modalVideo.removeAttribute('src');
    modalVideo.querySelectorAll('source').forEach((el) => el.remove());
    modalVideo.hidden = true;
  };

  const clearImage = () => {
    if (!modalImage) return;
    modalImage.removeAttribute('src');
    modalImage.alt = '';
    modalImage.hidden = true;
  };

  const updateNavButtons = () => {
    if (prevBtn) prevBtn.hidden = currentIndex <= 0;
    if (nextBtn) nextBtn.hidden = currentIndex >= openers.length - 1;
  };

  const setVideoSources = (sourcesJson) => {
    if (!modalVideo) return false;

    clearVideo();
    clearImage();

    let sources = [];
    try {
      sources = JSON.parse(sourcesJson || '[]');
    } catch (_e) {
      sources = [];
    }

    if (!sources.length) return false;

    sources.forEach((item) => {
      if (!item || !item.src) return;
      const source = document.createElement('source');
      source.src = item.src;
      if (item.type) source.type = item.type;
      modalVideo.appendChild(source);
    });

    modalVideo.hidden = false;
    modalVideo.load();
    return true;
  };

  const getSourcesJson = (btn) => {
    const fromAttr = btn.getAttribute('data-video-sources');
    if (fromAttr) return fromAttr;
    const script = btn.closest('.shir7-influencers__item')?.querySelector('[data-shir7-inf-sources]');
    return script?.textContent?.trim() || '';
  };

  const setStoryImage = (src, alt) => {
    if (!modalImage || !src) return false;
    clearVideo();
    clearImage();
    modalImage.src = src;
    modalImage.alt = alt || '';
    modalImage.hidden = false;
    return true;
  };

  const showStoryAt = (index) => {
    if (index < 0 || index >= openers.length) {
      closeModal();
      return;
    }

    clearPhotoTimer();
    currentIndex = index;
    const btn = openers[currentIndex];
    const sourcesJson = getSourcesJson(btn);
    const storyImage = btn.getAttribute('data-story-image');
    const label = btn.getAttribute('aria-label') || '';

    let opened = false;
    if (sourcesJson) {
      opened = setVideoSources(sourcesJson);
    } else if (storyImage) {
      opened = setStoryImage(storyImage, label);
    }

    if (!opened) {
      if (currentIndex < openers.length - 1) {
        showStoryAt(currentIndex + 1);
      } else {
        closeModal();
      }
      return;
    }

    modal.hidden = false;
    document.documentElement.classList.add('overflow-hidden');
    updateNavButtons();

    if (modalVideo && !modalVideo.hidden) {
      modalVideo.muted = false;
      modalVideo.volume = 1;
      modalVideo.currentTime = 0;
      const playPromise = modalVideo.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    } else if (modalImage && !modalImage.hidden) {
      photoTimer = setTimeout(() => {
        goNext();
      }, PHOTO_STORY_MS);
    }
  };

  const goNext = () => {
    if (currentIndex >= openers.length - 1) {
      closeModal();
      return;
    }
    showStoryAt(currentIndex + 1);
  };

  const goPrev = () => {
    if (currentIndex <= 0) return;
    showStoryAt(currentIndex - 1);
  };

  const openModal = (btn) => {
    const index = openers.indexOf(btn);
    showStoryAt(index >= 0 ? index : 0);
  };

  const closeModal = () => {
    clearPhotoTimer();
    modal.hidden = true;
    clearVideo();
    clearImage();
    document.documentElement.classList.remove('overflow-hidden');
  };

  openers.forEach((btn) => {
    btn.addEventListener('click', () => openModal(btn));
    btn.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openModal(btn);
      }
    });
  });

  closers?.forEach((el) => el.addEventListener('click', closeModal));
  prevBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    goPrev();
  });
  nextBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    goNext();
  });

  modalVideo?.addEventListener('ended', () => {
    if (modal.hidden) return;
    goNext();
  });

  document.addEventListener('keydown', (e) => {
    if (modal.hidden) return;
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowRight') {
      e.preventDefault();
      goNext();
    }
    if (e.key === 'ArrowLeft') {
      e.preventDefault();
      goPrev();
    }
  });
})();
